import styles from "../../styles/pages/DocumentationPage/DocumentationPage.module.css";
import React, { useState, useEffect, useContext } from 'react';

import { PostLead } from "./components/DocTabs/PostLead";
import { GetLead } from "./components/DocTabs/GetLead";
import { CreateDeposit } from "./components/DocTabs/CreateDeposit";
import { GetPaymentInformation } from "./components/DocTabs/GetPaymentInformation";
import { Postback } from "./components/DocTabs/Postback";
import { Tabs } from "./components/Tabs";
import { Title } from "../../components/UI/Custom/Title";
import { getAffiliateTokenApi } from "../../utils/api/Integration/getAffiliateTokenApi";
import { ThemeContext } from "../../context/ThemeContext";

export const DocumentationPage = () => {
    const { theme } = useContext(ThemeContext);
    const [activeTab, setActiveTab] = useState("PostLead");
    const [affiliateToken, setAffiliateToken] = useState(null);
    const [tokenLoading, setTokenLoading] = useState(true);
    const [tokenError, setTokenError] = useState(null);

    useEffect(() => {
        const fetchAffiliateToken = async () => {
            try {
                const token = await getAffiliateTokenApi();
                setAffiliateToken(token);
                setTokenLoading(false);
            } catch (error) {
                console.error("Ошибка при получении токена аффилиата:", error);
                setTokenError(error.message || "Не удалось получить токен аффилиата");
                setTokenLoading(false);
            }
        };

        fetchAffiliateToken();
    }, []);

    const infoGridClass = `${styles.infoGrid} ${theme === 'dark' ? styles.darkInfoGrid : ''}`;

    return (
        <div className={styles.wrapper}>
            <Title
                h2="Api Documentation"
            />
            <div className={infoGridClass}>
                <div className={styles.tabs}>
                    <Tabs
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                </div>
                <div className={styles.pageContent}>
                    {activeTab === "PostLead" && (
                        <PostLead affiliateToken={affiliateToken} loading={tokenLoading} error={tokenError} />
                    )}
                    {
                        activeTab === "GetLead" && <GetLead affiliateToken={affiliateToken} loading={tokenLoading} error={tokenError} />
                    }
                    {
                        activeTab === "CreateDeposit" && <CreateDeposit affiliateToken={affiliateToken} loading={tokenLoading} error={tokenError} />
                    }
                    {
                        activeTab === "CreateWithdrawal" && <CreateDeposit withdrawal affiliateToken={affiliateToken} loading={tokenLoading} error={tokenError} />
                    }
                    {
                        activeTab === "GetTransaction" && <GetPaymentInformation affiliateToken={affiliateToken} loading={tokenLoading} error={tokenError} />
                    }
                    {
                        activeTab === "GetBalance" && <GetPaymentInformation balance affiliateToken={affiliateToken} loading={tokenLoading} error={tokenError} />
                    }
                    {
                        activeTab === "PostBack" && <Postback />
                    }
                </div>
            </div>
        </div>
    );
};
